import React, {useEffect} from "react";
import styled from "styled-components";
import {Button, Col, DatePicker, Form, Image, Input, Row, Upload} from "antd";
import {useStore} from "../../store";
import moment from "moment";
import {UploadOutlined} from "@ant-design/icons";
import {BaseImageUrl} from "../../http/http";

const defaultIcon = require("../../image/default-pic.png")

const SpecimenDetail:React.FC = () => {

    const [form] = Form.useForm();
    const {specimenStore} = useStore();
    useEffect(() => {
        const {showBaseLibraryDetail} = specimenStore;
        const detail = JSON.parse(JSON.stringify(showBaseLibraryDetail));
        if (detail && detail.authenticateDate) {
            detail.authenticateDate = moment(detail.authenticateDate)
        }
        if (detail && detail.gatherDate) {
            detail.gatherDate = moment(detail.gatherDate)
        }
        if (detail && detail.entryDate) {
            detail.entryDate = moment(detail.entryDate)
        }
        form.setFieldsValue(detail);
    }, []);
    const specimenForm = () => {
        return <Form preserve={false} title={"标本信息"}  disabled={true} form={form} layout={"vertical"} size={"middle"} >
            <Row gutter={24}>
                <Col span={8}>
                    <Form.Item label={"馆代码:"} name={"libraryCode"} required={false}><Input/></Form.Item>
                </Col>
                <Col span={8}>
                    <Form.Item label={"流水号:"} name={"serialNumber"} required={false}><Input/></Form.Item>
                </Col>
                <Col span={8}>
                    <Form.Item label={"条形码:"} name={"barCode"} required={false}><Input/></Form.Item>
                </Col>
                <Col span={8}>
                    <Form.Item label={"模式类型:"} name={"patternType"} required={false}><Input/></Form.Item>
                </Col>
                <Col span={8}>
                    <Form.Item label={"库存:"} name={"inventory"} required={false}><Input/></Form.Item>
                </Col>
                <Col span={8}>
                    <Form.Item label={"标本状态:"} name={"specimenStatu"} required={false}><Input/></Form.Item>
                </Col>
                <Col span={8}>
                    <Form.Item label={"采集人:"} name={"gatherer"} required={false}><Input/></Form.Item>
                </Col>
                <Col span={8}>
                    <Form.Item label={"采集号:"} name={"gatherNumber"} required={false}><Input/></Form.Item>
                </Col>
                <Col span={8}>
                    <Form.Item label={"采集日期:"} name={"gatherDate"} required={false}><DatePicker/></Form.Item>
                </Col>
                <Col span={8}>
                    <Form.Item label={"国家:"} name={"country"} required={false}><Input/></Form.Item>
                </Col>
                <Col span={8}>
                    <Form.Item label={"省市:"} name={"province"} required={false}><Input/></Form.Item>
                </Col>
                <Col span={8}>
                    <Form.Item label={"区县:"} name={"district"} required={false}><Input/></Form.Item>
                </Col>
                <Col span={8}>
                    <Form.Item label={"海拔:"} name={"altitude"} required={false}><Input/></Form.Item>
                </Col>
                <Col span={8}>
                    <Form.Item label={"负海拔:"} name={"negativeAltitud"} required={false}><Input/></Form.Item>
                </Col>
                <Col span={8}>
                    <Form.Item label={"图片:"} required={true}>
                        {specimenStore.showBaseLibraryDetail?.imgUrl && <Image preview={false} src={BaseImageUrl+specimenStore.showBaseLibraryDetail?.imgUrl} fallback={defaultIcon}/>}
                    </Form.Item>
                </Col>
            </Row>
        </Form>
    }

    const speciesForm = () => {
        return <Form preserve={false} title={"物种信息"} disabled={true} form={form} layout={"vertical"} size={"middle"} >
            <Row gutter={24}>
                <Col span={8}>
                    <Form.Item label={"科:"} name={"specimenFamily"} required={false}><Input/></Form.Item>
                </Col>
                <Col span={8}>
                    <Form.Item label={"属:"} name={"specimenGenus"} required={false}><Input/></Form.Item>
                </Col>
                <Col span={8}>
                    <Form.Item label={"种:"} name={"specimenSpecies"} required={false}><Input/></Form.Item>
                </Col>
                <Col span={8}>
                    <Form.Item label={"定名人:"} name={"nominator"} required={false}><Input/></Form.Item>
                </Col>
                <Col span={8}>
                    <Form.Item label={"种下等级:"} name={"plantingGrade"} required={false}><Input/></Form.Item>
                </Col>
                <Col span={8}>
                    <Form.Item label={"中文名:"} name={"specimenName"} required={false}><Input/></Form.Item>
                </Col>
                <Col span={8}>
                    <Form.Item label={"习性:"} name={"habit"} required={false}><Input/></Form.Item>
                </Col>
                <Col span={8}>
                    <Form.Item label={"体高:"} name={"bodyHeight"} required={false}><Input/></Form.Item>
                </Col>
                <Col span={8}>
                    <Form.Item label={"胸径:"} name={"dbh"} required={false}><Input/></Form.Item>
                </Col>
                <Col span={8}>
                    <Form.Item label={"茎:"} name={"stems"} required={false}><Input/></Form.Item>
                </Col>
                <Col span={8}>
                    <Form.Item label={"叶:"} name={"leaf"} required={false}><Input/></Form.Item>
                </Col>
                <Col span={8}>
                    <Form.Item label={"花:"} name={"flowers"} required={false}><Input/></Form.Item>
                </Col>
                <Col span={8}>
                    <Form.Item label={"果实:"} name={"fruit"} required={false}><Input/></Form.Item>
                </Col>
                <Col span={8}>
                    <Form.Item label={"寄主:"} name={"host"} required={false}><Input/></Form.Item>
                </Col>
            </Row>
        </Form>

    }

    const identificationForm = () => {
        return <Form preserve={false} title={"鉴定信息"} disabled={true} form={form} layout={"vertical"} size={"middle"}>
            <Row gutter={24}>
                <Col span={8}>
                    <Form.Item label={"鉴定人:"} name={"authenticateEr"} required={false}><Input/></Form.Item>
                </Col>
                <Col span={8}>
                    <Form.Item label={"鉴定日期:"} name={"authenticateDate"} required={false}><DatePicker/></Form.Item>
                </Col>
                <Col span={8}>
                    <Form.Item label={"备注:"} name={"remarks"} required={false}><Input/></Form.Item>
                </Col>
                <Col span={8}>
                    <Form.Item label={"地名:"} name={"placeName"} required={false}><Input/></Form.Item>
                </Col>
                <Col span={8}>
                    <Form.Item label={"生境:"} name={"habitat"} required={false}><Input/></Form.Item>
                </Col>
                <Col span={8}>
                    <Form.Item label={"经度:"} name={"lon"} required={false}><Input/></Form.Item>
                </Col>
                <Col span={8}>
                    <Form.Item label={"纬度:"} name={"lat"} required={false}><Input/></Form.Item>
                </Col>
                <Col span={8}>
                    <Form.Item label={"备注2:"} name={"remark2"} required={false}><Input/></Form.Item>
                </Col>
                <Col span={8}>
                    <Form.Item label={"录入员:"} name={"entryClerk"} required={false}><Input/></Form.Item>
                </Col>
                <Col span={8}>
                    <Form.Item label={"录入日期:"} name={"entryDate"} required={false}><DatePicker/></Form.Item>
                </Col>
            </Row>
        </Form>

    }
    return(<Wrapper>
        <div style={{fontSize: "17px", margin: "10px 0", fontWeight:"450"}}>标本信息</div>
         {specimenForm()}
        <div style={{fontSize: "17px", margin: "10px 0", fontWeight:"450"}}>物种信息</div>
        {speciesForm()}
        <div style={{fontSize: "17px", margin: "10px 0", fontWeight:"450"}}>鉴定信息</div>
        {identificationForm()}
    </Wrapper>);
}

export default SpecimenDetail;


const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  padding: 15px 30px;
  max-height: 500px;
  overflow: auto;
  .ant-picker{
    width: 100%;
  }
`;
const secondTitle = styled.div`
  & {
    font-size: 17px;
    line-height: 17px;
    margin: 10px 0;
  }
`;